<div class="CalendarEntry">
	<label *ngIf="DayNumber != -1" style="text-align: right; font-size: 14px">{{ DayNumber }}</label>

	<div *ngIf="DayNumber != -1" class="TwoCol">
		<label>School Day: </label>
		<select
			[disabled]="loadingSchools == true || loadingPrefs == true || loadingDayOps == true || loadingBellSchedule == true || loadingDayEntries == true"
			class="form-control"
			name="SchoolDay"
			(ngModelChange)="onSDChange($event)"
			[(ngModel)]="SchoolDayID"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstSchoolDay" [ngValue]="o.DayID">
				{{ o.DayDesc }}
			</option>
		</select>

		<label *ngIf="UseSchoolBellSchedule == true">Bell Schedule: </label>
		<select
			*ngIf="UseSchoolBellSchedule == true"
			[disabled]="EditDisable()"
			class="form-control"
			name="BellSchedule"
			(ngModelChange)="onBellChange($event)"
			[(ngModel)]="BellScheduleID"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstBellSchedule" [ngValue]="o.BellScheduleID">
				{{ o.BellScheduleDesc }}
			</option>
		</select>

		<label>Open: </label>
		<input [disabled]="EditDisable()" class="form-control CheckSize" type="checkbox" (ngModelChange)="onOpenChange($event)" [(ngModel)]="IsOpen" />
	</div>
</div>
